import "./OptionChooser.css";

interface DropDownProps {
  options: Record<string, string>;
  selectedOption: string | undefined;
  setSelectedOption: (option: string | undefined) => void;
  optionDescription: string;
}

const DropDown = ({
  options,
  selectedOption,
  setSelectedOption,
  optionDescription,
}: DropDownProps) => {
  if (!selectedOption) {
    setSelectedOption(Object.keys(options)[0]);
  }
  return (
    <div>
      <label className="store-front-label">{optionDescription}</label>
      <select
        id="size-select"
        className="store-front-input"
        value={selectedOption || ""}
        onChange={(e) => setSelectedOption(e.target.value)}
      >
        {Object.entries(options).map(([key, value]) => (
          <option key={key} value={key}>
            {value}
          </option>
        ))}
      </select>
    </div>
  );
};

export default DropDown;
